import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="position-fixed fixed-bottom text-center w-100 footer pb-2 pt-2">
      <p className="mr-3 mb-0">
        EasyNotification® è un marchio registrato di proprietà di Progetti e
        Soluzioni SpA
      </p>
      <Link to="/Informativa_Privacy.pdf" target="_blank">
        Privacy
      </Link>
    </footer>
  );
};

export default Footer;
